import "./openFile.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import ModalBody from "../../components/modal/ModalBody";
import ModalRow from "../../components/modal/ModalRow";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import { uiStateOperations, uiStateSelectors } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { mergeDispatchToProps } from "../../utils/codeSplit";

class FileVersionTooLowModal extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.FILE_VERSION_OPENED
    });
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.FILE_VERSION_CLOSED
    });
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  checkForUpdates() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.USER_INITIATED_CHECK_FOR_LICENSED_UPDATE
    });
  }

  render() {
    let modalHeading = (
      <div className="FileVersionTooLowModalClose" onClick={this.props.onCloseClick}>
        <svg className="closeIcon mono">
          <use xlinkHref={"#interfaceClose"} />
        </svg>
      </div>
    );
    let modalFooter = null;
    let fixedHeight = this.props.openFileAllowReadonly ? 500 : 350;

    return (
      <ModalView
        className="FileVersionTooLowModal"
        header={modalHeading}
        footer={modalFooter}
        fixedHeight={fixedHeight}
        onBackdropClick={this.props.onCloseClick}
      >
        <ModalBody>
          <h1>Update required</h1>
          <div className="description">
            <ModalRow alignMiddle={true}>
              The file you are trying to open was created in a newer version of Aeon Timeline. Please upgrade to the
              latest version and try again.
            </ModalRow>
          </div>
          <div className="inputs">
            <ModalRow alignMiddle={true}>
              <FormButton onClick={this.checkForUpdates} primary={true} label="Check for updates" />
            </ModalRow>
          </div>
          {this.props.openFileAllowReadonly ? (
            <Fragment>
              <div className="description">
                <ModalRow alignMiddle={true}>
                  You can alternatively open the file in read only mode without updating.
                </ModalRow>
              </div>
              <div className="inputs">
                <ModalRow alignMiddle={true}>
                  <FormButton onClick={() => {}} primary={true} label="Open as read only" />
                </ModalRow>
              </div>
            </Fragment>
          ) : null}
          <div className="links">
            <ModalRow alignMiddle={true}>
              <FormButton onClick={this.props.onCloseClick} linkStyle={true} label="Cancel without opening" />
            </ModalRow>
          </div>
        </ModalBody>
      </ModalView>
    );
  }
}

FileVersionTooLowModal.propTypes = {
  openFileAllowReadonly: PropTypes.bool,
  onCloseClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    openFileAllowReadonly: uiStateSelectors.getUiStateOpenFileAllowReadonly(state.present)
  };
};

const readonlyActions = {
  onCloseClick: uiStateOperations.hideFileVersionTooLowModal
};

const editingActions = {};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FileVersionTooLowModal);
